export const MODULE_PREFIX = 'vehicleProtections';
